<template>

	<transition
		name="modalOverlayFade"
		enter-active-class="fadeIn"
		leave-active-class="fadeOut">

		<div class="modal is-active" v-on:click="$emit('close')">

			<i class="fa fa-times icon-button close-button" v-on:click="$emit('close')"></i>

			<div class="image-container">

				<div v-if="!isPdf" class="d-flex justify-content-center" ref="imageWrapper">

					<image-with-layers :image-url="url" :layers="layers"></image-with-layers>

				</div>

				<iframe v-else-if="isPdf"
					width="100%"
					height="100%"
					:src="url">
				</iframe>
			</div>

		</div>

	</transition>

</template>
<script type="text/javascript">

import ImageWithLayers from "./ImageWithLayers";

export default {
	name: "ImageViewer",
	components: {
		ImageWithLayers
	},
	props: [
		"url",
		"forcePdf",
		"layers"		// Layers overtop image, if they exist
	],
	computed: {
		isPdf() {
			if (this.forcePdf)
				return true

			let split = this.url.split("?")

			split = split[0].split(".")

			if (split[split.length - 1].toLowerCase() == 'pdf')
				return true
			else
				return false
		}
	}

}
</script>

<style type="text/css" scoped>

	.modal.is-active {
		background-color: rgba(10,10,10,0.8);
		display: block;
	}

	.image-container {
		text-align: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		height: 100vh;
	}

	.close-button {
		position: fixed;
		color: white;
		top: 5px;
		right: 5px;
		font-size: 24pt;
	}

	img {
		max-width: 100%;
		max-height: 100%;
	}

	iframe {
		max-width: calc(100% - 80px);
		width: 80%;
		height: 80%;
		margin: auto;
		border: none;
	}

	@media (max-width: 400px) {
		iframe {
			max-width: calc(100% - 80px);
			width: 90%;
			height: 80%;
			margin: auto;
		}
	}

</style>